import { StickyBar, StickyBarDirection, StickyBarProps } from '@app/components/molecules/sticky-bar';

export const CheckoutStickyBar = ({ children, ...props }: StickyBarProps) => {
    return (
        <StickyBar
            display={'flex'}
            px={'gutterWidth'}
            py={2}
            gap={'gutterWidth'}
            alignItems={'center'}
            justifyContent={'space-between'}
            direction={StickyBarDirection['bottom']}
            {...props}
        >
            {children}
        </StickyBar>
    );
};
